import React from 'react';

import { Control } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';

import { useLicense } from '../LicenseProvider.tsx';

function ExtractBodyDescriptorToggle() {
  const { isFeatureAvailable } = useLicense();
  const isBodyLicenseAvailable = isFeatureAvailable('estimations.body_attributes');
  const { control } = useFormContext();
  const estimateBody = useWatch({ name: 'estimate.body' });

  return (
    <Control.Switch
      control={control}
      disabled={!estimateBody || !isBodyLicenseAvailable}
      name="extract.bodyDescriptor"
    />
  );
}

export { ExtractBodyDescriptorToggle };
